// Einstiegspunkt des Zeichnens. Reihenfolge ist Stapelreihenfolge: Rahmen und
// Gitter nach hinten, Trefferflächen nach vorn.

import * as d3 from "d3";

import { drawAxis } from "./layers/axis";
import { drawForward } from "./layers/forward";
import { drawFrame } from "./layers/frame";
import { drawGrid } from "./layers/grid";
import { drawHistoryCells, drawHistoryLines } from "./layers/history";
import { drawHover } from "./layers/hover";
import type { HoverHandler } from "./layers/hover";
import { drawMeetings } from "./layers/meetings";
import { drawStrip } from "./layers/strip";
import type { Model } from "./model";
import type { Strings } from "../strings";

export function renderChart(
    el: SVGSVGElement,
    model: Model,
    strings: Strings,
    lang: string,
    onHover: HoverHandler,
): void {
    const svg = d3.select(el);
    svg.selectAll("*").remove();

    drawFrame(svg, model, strings);
    drawGrid(svg.append("g"), model, lang);
    drawHistoryCells(svg.append("g"), model);
    drawMeetings(svg.append("g"), model, lang);
    drawHistoryLines(svg.append("g"), model);
    drawForward(svg.append("g"), model, lang);
    drawStrip(svg.append("g"), model);
    drawAxis(svg.append("g"), model, lang);
    drawHover(svg.append("g"), model, lang, onHover);
}